// src/api/api.js
import axios from "axios";

const withTrailingSlash = (url) => `${url}`.replace(/\/?$/, "/");

// Same-origin defaults work on Hostinger when React build files and /backend
// are uploaded under the same public_html directory.
export const API_BASE_URL = withTrailingSlash(
  process.env.REACT_APP_API_URL || "/backend/api/"
);
export const IMAGE_URL = withTrailingSlash(
  process.env.REACT_APP_IMAGE_URL || "/backend/uploads/"
);

// Create an axios instance with default headers
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// User and general endpoints
export const getFoodItems   = () => api.get("get_food.php");
// export const getFoodItem    = (id) => api.get(`get_food.php?id=${encodeURIComponent(id)}`);
export const getFoodItem = (id) => api.get(`get_food.php?id=${id}`);

export const addToCart      = (cartData) => api.post("add_to_cart.php", cartData);
export const getCartItems   = (userId) => api.get(`get_cart.php?user_id=${userId}`);
export const updateCart     = (cartData) => api.post("update_cart.php", cartData);
export const removeFromCart = (cartData) => api.post("remove_from_cart.php", cartData);

// Razorpay integration: generate order
export const generateOrder  = (params) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`generate_order.php?${qs}`);
};

// After payment, verify signature and place order
export const verifyAndPlace = (payload) => api.post("verify_and_place_order.php", payload);

// Place simple order (Pay at Counter)
export const checkoutOrder  = (orderData) => api.post("place_order.php", orderData);

// Authentication
export const registerUser   = (userData) => api.post("register.php", userData);
export const loginUser      = (userData) => api.post("login.php", userData);

// Categories endpoints
export const getCategories  = () => api.get("get_categories.php");
export const addCategory    = (categoryData) => api.post("add_category.php", categoryData);
export const updateCategory = (categoryData) => api.post("update_category.php", categoryData);
export const deleteCategory = (categoryData) => api.post("delete_category.php", categoryData);

// Admin endpoints
export const addFood        = (foodData) => api.post("add_food.php", foodData);
export const updateFood     = (foodData) => api.post("update_food.php", foodData);
export const deleteFood     = (foodData) => api.post("delete_food.php", foodData);
export const getOrders      = (userId) =>
  userId ? api.get(`get_orders.php?user_id=${userId}`) : api.get("get_orders.php");

// Customer management
export const getCustomers   = () => api.get("get_customers.php");
export const deleteCustomer = (payload) => api.post("delete_customer.php", payload);

// Order status update and deletion
export const updateOrderStatus = (orderId) => api.post("update_order_status.php", { order_id: orderId });
export const deleteOrder       = (orderData) => api.post("delete_order_by_admin.php", orderData);

// File upload
export const uploadFoodImage = (file) => {
  const formData = new FormData();
  formData.append("image", file);
  return api.post("upload_food_image.php", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// Password recovery
export const forgotPassword = (data) => api.post('forgot_password.php', data);
export const resetPassword  = (data) => api.post('reset_password.php', data);

// Google login
export const loginWithGoogle = (token) => api.post("google_login.php", { token });

export default api;
